export const CANVAS_DROPPABLE_ID = 'canvas';
